export const isGtmLoaded = () => {
  if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
    return false
  }

  return window.dataLayer.some((item) => item.event === 'gtm.load')
}

export const waitForGtmLoaded = (callback: () => void) => {
  if (isGtmLoaded()) {
    callback()
    return
  }

  const intervalId = setInterval(() => {
    if (!isGtmLoaded()) {
      return
    }

    callback()
    clearInterval(intervalId)
  }, 500)
}
